import React from 'react'
import { StyledToggle, StyledSwitch } from '../../styles/devices/Buttons'

export const Toggle = ({ selected=false, onClick }: { selected?: boolean, onClick?: any }) => {
  return (

    <StyledToggle onClick={onClick} selected={selected}>
      <StyledSwitch selected={selected}/>
    </StyledToggle>
  )
}

